import { render, staticRenderFns } from "./DegreesCrud.vue?vue&type=template&id=02bfbca7&scoped=true"
import script from "./DegreesCrud.vue?vue&type=script&lang=js"
export * from "./DegreesCrud.vue?vue&type=script&lang=js"
import style0 from "./DegreesCrud.vue?vue&type=style&index=0&id=02bfbca7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bfbca7",
  null
  
)

export default component.exports